export default __webpack_public_path__ + "static/media/bookCover.73ecde82.png";